// Carat Icon:
// Simple carat (>) icon.

// Core
import React from 'react'

const Carat = () => (
  <svg width="100%" viewBox="0 0 13 22">
    <g fillRule="evenodd">
      <g transform="translate(-488.000000, -591.000000)" fillRule="nonzero">
        <polygon points="488.428658 592.571342 489.571342 591.428658 500.142685 602 489.571342 612.571342 488.428658 611.428658 497.857315 602" />
      </g>
    </g>
  </svg>
)

export default Carat
